import { render, staticRenderFns } from "./c-rich-text.vue?vue&type=template&id=13fc88b0&scoped=true&"
import script from "./c-rich-text.vue?vue&type=script&lang=js&"
export * from "./c-rich-text.vue?vue&type=script&lang=js&"
import style0 from "./c-rich-text.vue?vue&type=style&index=0&id=13fc88b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc88b0",
  null
  
)

export default component.exports